import React, { Component } from 'react';



class IconIndicator extends Component {
  renderValue() {
    if(typeof this.props.integer != 'undefined') {
      return this.props.integer?this.props.integer:0;
    }
    return this.props.children;
  }
  render() {
    return (
      <span className={` wsnw ${this.props.className}`}>
        <span className={`mdi mdi-${this.props.icon} s-fs12 m-fs18 sc1 vam`}></span>
        <span className="vam pleft5 s-fs12 m-fs16">{this.renderValue()}</span>
      </span>
    )
  }
}


export default IconIndicator;